List of event IDs to filter which events are to be replayed.

This is an alternative to the `filter` argument, providing the ability to replay a list of specific events by their IDs.
`eventIds` and `filter` cannot be specified in the same mutation.

A maximum of 100 event IDs may be provided.
